module.exports = __webpack_public_path__ + "img/22.0530e673.png";